/**
 * @file automatically generated from MApp.Endpoints.FeatureAnalyzerController
 */

import { MetadataClient } from '../metadata-client';
import { ISaveAnalyzerView, IAnalyzerView, IAnalyzerViewListItem, IValidationResult, IAnalyzerVectorSet, IAnalyzerDataset, IAnalyzerLegend, IAnalyzerAttributeData, IGeoServiceListItem, IAnalyzerBaseMap } from '../models';

export class FeatureAnalyzerClient extends MetadataClient {

	public static saveView(view: ISaveAnalyzerView, requestInit?: RequestInit) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(view),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static uploadView(formData: FormData, viewName: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(viewName)}/upload`, {
				method: 'POST',
				body: formData,
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static updateView(id: string, view: ISaveAnalyzerView, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(view),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getView(name: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<IAnalyzerView>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(name)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getViewById(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<IAnalyzerView>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(id)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static cloneView(id: string, newName: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/clone/${encodeURIComponent(id)}?newName=${encodeURIComponent(newName)}`, {
				method: 'POST',
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getViews(requestInit?: RequestInit) {
		return MetadataClient.ajax<IAnalyzerViewListItem[]>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static deleteView(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(id)}`, {
				method: 'DELETE',
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static updateViewConfig(name: string, view: any[], requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(name)}/configuration`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(view),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getViewConfig(name: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/${encodeURIComponent(name)}/configuration`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static isValidView(name: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<IValidationResult>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/views/isvalid?name=${encodeURIComponent(name)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getPreview(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/datasets/${encodeURIComponent(id)}/preview`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getAttributeDataPreview(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/datasets/${encodeURIComponent(id)}/attributeDataPreview`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getAttributeValues(id: string, attribute: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/datasets/${encodeURIComponent(id)}/values/${encodeURIComponent(attribute)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getValues(id: string, attributes: string[], requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/featureanalyzer/datasets/${encodeURIComponent(id)}/values`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				body: JSON.stringify(attributes),
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getVectorSets(requestInit?: RequestInit) {
		return MetadataClient.ajax<IAnalyzerVectorSet[]>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/vectorsets`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getLiveDatasets(requestInit?: RequestInit) {
		return MetadataClient.ajax<IAnalyzerDataset[]>(
			new Request(MetadataClient.endpointsUrl + `api/v1/featureanalyzer/datasets/live`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getCachedDatasets(requestInit?: RequestInit) {
		return MetadataClient.ajax<IAnalyzerDataset[]>(
			new Request(MetadataClient.endpointsUrl + `api/v1/featureanalyzer/datasets/cached`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getLegends(requestInit?: RequestInit) {
		return MetadataClient.ajax<IAnalyzerLegend[]>(
			new Request(MetadataClient.endpointsUrl + `api/v3/featureanalyzer/legends`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getAttributes(requestInit?: RequestInit) {
		return MetadataClient.ajax<IAnalyzerAttributeData[]>(
			new Request(MetadataClient.endpointsUrl + `api/v1/featureanalyzer/attributes`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getDatasetBounds(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/datasets/${encodeURIComponent(id)}/bounds`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getVectorSet(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/vectorsets/${encodeURIComponent(id)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getBaseMaps(requestInit?: RequestInit) {
		return MetadataClient.ajax<IGeoServiceListItem[]>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/basemaps`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getBaseMap(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<IAnalyzerBaseMap>(
			new Request(MetadataClient.endpointsUrl + `api/v2/featureanalyzer/basemaps/${encodeURIComponent(id)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}

	public static getMapViewStyleSet(id: string, requestInit?: RequestInit) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v4/featureanalyzer/mapViewStyle/${encodeURIComponent(id)}`, {
				cache: 'no-cache',
				...requestInit
			})
		);
	}
}
